import { checkInvite } from '../../../api/authApi';

export const CheckInviteMixin = {
  methods: {
    checkInvite: async function (showMessage = false) {
      const invitations = await checkInvite();
      if (invitations) {
        if (showMessage) {
          this.$noty.show(`${invitations.length ? 'Some invites were found for your email:' : 'No active invites for your email:'} ${this.personData.email}`);
        }
        if (invitations.length !== 0) {
          this.personData.invitedMe = invitations;
        }
      } else {
        this.$noty.error('An Error occurred');
      }
    },
  },
};
